let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([require("./helpers/browser/css-loader")(require('./helpers/bundle-manifest').resolve("kcRQL")), load("5s7qn")]).then(() => parcelRequire('7wJ5d'));